export default {
  name: "HeroSection",

  data() {
    return ({
      hero_data:{
        eyebrow: "Real-time property intelligence",
        headline_dark: "STOP GUESSING.",
        headline_light: "START SEEING.",
        sub_headline: "Energy, security and connectivity data from every property you manage — unified in one live dashboard.",
        btn_text: "Access Dashboard",
      }
    });
  },
};
